module.exports = __webpack_public_path__ + "img/tt.4705d420.svg";